import styles from "./index.module.scss";
import Image from "next/legacy/image";
export function DictionaryModule() {
  return (
    <>
      <div className={styles["tu-dien-kinh-doanh"]}>
        <h2>
          <span>Từ điển kinh doanh theo ngành hàng</span>
        </h2>
        <p>Hãy lựa chọn lĩnh vực bạn đang kinh doanh và tìm hiểu ngay những bí quyết bán hàng thực chiến hiệu quả nhất</p>
        <ul>
          <li>
            <a href="https://www.sapo.vn/blog/tra-cuu#t">
              <Image src={process.env.NEXT_PUBLIC_BASE_PATH + "/images/tu-dien/icon-tap-hoa.png"} alt="Tạp hóa" width="29" height="29" />
              Tạp hóa
            </a>
          </li>
          <li>
            <a href="https://www.sapo.vn/blog/tra-cuu#s">
              <Image src={process.env.NEXT_PUBLIC_BASE_PATH + "/images/tu-dien/icon-sieu-thi-mini.png"} alt="Siêu thị mini" width="29" height="26" />
              Siêu thị mini
            </a>
          </li>
          <li>
            <a href="https://www.sapo.vn/blog/tra-cuu#m">
              <Image src={process.env.NEXT_PUBLIC_BASE_PATH + "/images/tu-dien/icon-my-pham.png"} alt="Mỹ phẩm" width="27" height="28" />
              Mỹ phẩm
            </a>
          </li>
          <li>
            <a href="https://www.sapo.vn/blog/tra-cuu#c">
              <Image src={process.env.NEXT_PUBLIC_BASE_PATH + "/images/tu-dien/icon-quan-cafe.png"} alt="Quán cafe" width="29" height="29" />
              Quán cafe
            </a>
          </li>
          <li>
            <a href="https://www.sapo.vn/blog/tra-cuu#n">
              <Image src={process.env.NEXT_PUBLIC_BASE_PATH + "/images/tu-dien/icon-noi-that.png"} alt="Nội thất" width="35" height="25" />
              Nội thất
            </a>
          </li>
          <li>
            <a href="https://www.sapo.vn/blog/tra-cuu#l">
              <Image src={process.env.NEXT_PUBLIC_BASE_PATH + "/images/tu-dien/icon-lazada.png"} alt="Lazada" width="31" height="25" />
              Lazada
            </a>
          </li>
          <li>
            <a href="https://www.sapo.vn/blog/tra-cuu">
              <Image
                src={process.env.NEXT_PUBLIC_BASE_PATH + "/images/tu-dien/icon-tat-ca-nganh-hang.png"}
                alt="Tất cả ngành hàng"
                width="22"
                height="28"
              />
              Tất cả ngành hàng
            </a>
          </li>
        </ul>
      </div>
    </>
  );
}
